import React from "react";
import { ContentItem } from "./ContentItem";
import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";

export function ContentsSection() {
    const { t } = useTranslation();
    return (
        <div
            id="contents"
            className="flex w-full bg-white justify-start 2xl:justify-center px-16 py-12 md:p-24 md:px-32"
        >
            <div className="flex w-full 2xl:max-w-screen-lg items-center justify-center ">
                <div className="flex flex-col items-center justify-center w-full min-w-xs md:mb-0">
                    <div className="w-full text-lg text-center font-bold max-w-screen-lg mb-12">
                        {t("contents-section-text")}
                    </div>
                    <div className="flex w-full flex-wrap md:flex-nowrap">
                        <ContentItem
                            img={getImage("timber_purchases")}
                            label={t("timber-purchases")}
                            href="#timber-purchases"
                            className="md:mr-12"
                        />
                        <ContentItem
                            img={getImage("forest_management")}
                            label={t("forest-management")}
                            href="#forest-management"
                            className=""
                        />
                        <ContentItem
                            img={getImage("damage_inventory")}
                            label={t("damage-inventory")}
                            href="#damage-inventory"
                            className="md:ml-12"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
